// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"7d3e8d7f","453":"d9397247","455":"6a539bf4","865":"dcbf3377","977":"1854fc6c"}[chunkId] + ".chunk.js";
};